import React, { useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import Icon from '@mdi/react';
import { mdiChevronDown } from '@mdi/js';
import envisionLogo from '../../assets/images/envision-logo-lg.png';
import { getAuthUser } from '../../utils/auth.util';
import { getCompanyCode, setCompanyCode } from '../../config/axios.config';

function CurrentCompany() {
  const { companyList } = getAuthUser();

  const getLocalStorageCompany = () => {
    const companyNo = getCompanyCode();
    const localStorageCompany = companyList?.find(
      company => company.Code === companyNo,
    );
    return localStorageCompany;
  };

  const [isCompanyDropdown, setIsCompanyDropdown] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(
    getLocalStorageCompany()?.Description ?? 'Select Company',
  );

  const toggleCompanyDropdown = () => {
    setIsCompanyDropdown(!isCompanyDropdown);
  };

  const handleSelectedCompany = company => {
    setSelectedCompany(company.Description);
    setCompanyCode(company.Code);
    window.location.reload();
  };

  return (
    <Dropdown isOpen={isCompanyDropdown} toggle={toggleCompanyDropdown}>
      <DropdownToggle
        style={{
          minWidth: '300px',
          backgroundColor: '#F2F4F7',
          border: '1px solid #D0D5DD',
          color: '#475467',
          borderRadius: '11px',
          padding: '8px',
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <img
            src={envisionLogo}
            className="rounded-circle me-2"
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: 'white',
            }}
            alt=""
            height="22"
          />
          {selectedCompany}
        </div>

        <Icon path={mdiChevronDown} size={0.8} color="#667085" />
      </DropdownToggle>
      <DropdownMenu>
        {companyList?.map(company => (
          <DropdownItem
            key={company.Code}
            onClick={() => handleSelectedCompany(company)}
          >
            {company.Description}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default CurrentCompany;
